// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  adalConfig: {
    tenant: '06219a4a-a835-44d5-afaf-3926343bfb89',
    clientId: 'c3489c92-26d5-4a80-bd26-81ac540e1672',
    //clientId: '4d4f8480-c868-43e9-b6e5-f9213cad7294',
    authority: 'https://login.microsoftonline.com/06219a4a-a835-44d5-afaf-3926343bfb89',
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
    scopes: ["api://c3489c92-26d5-4a80-bd26-81ac540e1672/user_impersonation"],
    endpoints: {
      "[HOME_URL_WEB_API]": "[HOME_WEB_API_GUID]"
    }
  },

  //DEV 
  //
   baseUrl: "https://dev.api.koreaindent.syngentadigitalapps.com/",
   sapUrl: "https://syngentaapitest.apimanagement.hana.ondemand.com:443/REST/SalesOrder",

  //PROD
  // sapUrl:"https://syngentaapi.apimanagement.hana.ondemand.com:443/REST/SalesOrder",
  // baseUrl:"https://syn-as-sgaz-prd-webapp-koreadg.azurewebsites.net/" 

};

/*

 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
